module.exports = __webpack_public_path__ + "img/ic_food_manage_bottom_item_img3.80fe9c75.png";